// A limitation date as recorded: the stored value, or null when nothing was
// recorded. "Not recorded" arrives two ways — NULL (version-23: a link writes
// last_date NULL, Aaron 2026-10-06) and, on a tenant not yet upgraded or a row
// legacy wrote, the MySQL zero-date '0000-00-00' as a string. Both read as null,
// which the Aircraft List grids render as "—", never as a date.
export const EMDASH = "—";

export function recordedDate(value: string | null | undefined): string | null {
  if (value === null || value === undefined) return null;
  const text = String(value).trim();
  return !text || text.startsWith("0000-00-00") ? null : text;
}
